<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-pencil"></i><strong>Entidade</strong>
        </div>
        <div class="card-block">
          <form>
            <div class="form-group" :class="{'has-danger': errors.has('nome da entidade') }">
              <label class="col-form-label">Nome da entidade</label>
              <input class="form-control" type="text" name="nome da entidade" v-model="name" v-validate="'required'" :disabled="id !== undefined">
              <span v-show="errors.has('nome da entidade')" class="form-control-feedback">{{ errors.first('nome da entidade') }}</span>
            </div>
            <vue-json-editor v-model="context" :showBtns="false" ></vue-json-editor>
            <br>
            <div class="form-group">
              <label class="form-label">Identificadores</label>
              <v-select multiple :options="availableIdentifiers" v-model="identifiers"></v-select>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="pull-right">
            <router-link :to="'/cerebro/entities'" class="btn btn-sm">
              <i class="fa fa-chevron-left"></i> Cancelar
            </router-link>
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="save"><i class="fa fa-save"></i> Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vueJsonEditor from 'vue-json-editor'
import vSelect from 'vue-select'

export default {
  name: 'entity',
  components: { vueJsonEditor, vSelect },
  data () {
    return {
      context: { },
      identifiers: [],
      name: '',
      id: undefined
    }
  },
  computed: {
    availableIdentifiers: function () {
      return Object.keys(this.context)
    }
  },
  created () {
    var entity = this.$route.params.entity
    var id = this.$route.params.id

    if (entity !== undefined && id !== undefined) {
      var query = `cerebro?id=${id}&entity=${entity}`
      axios.get(process.env.API_URL + query).then(response => {
        this.id = id
        this.name = entity
        this.context = response.data.content
        this.identifiers = response.data.identifiers.map(function(x) { return x.attributeName })
      }).catch(err => {
        console.log(err.response)
        this.showError('Ops. Ocorreu um erro ao carregar a entidade.')
      })
    } else {
      this.context = { foo: 'bar' }
    }
  },
  watch: {
    'context': function (val, oldVal) {
      this.identifiers = this.identifiers.filter(identifier => Object.keys(this.context).includes(identifier))
    }
  },
  methods: {
    save () {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        if (this.id === undefined) {
          axios.post(process.env.API_URL + 'cerebro', {
            name: this.name,
            identifiers: this.identifiers,
            context: JSON.stringify(this.context)
          }).then(response => {
            this.showSuccess(`Entidade cadastrada com sucesso.\n Id gerado: ${response.data[0]}.`)
            this.$router.push('/cerebro/entities')
          }).catch(err => {
            console.log(err.response)
            this.showError('Ops. Ocorreu um erro ao salvar a entidade ')
            this.$router.push('/cerebro/entities')
          })
        } else {
          axios.put(`${process.env.API_URL}cerebro?id=${this.id}`, {
            name: this.name,
            identifiers: this.identifiers,
            context: JSON.stringify(this.context)
          }).then(response => {
            this.showSuccess('Entidade atualizada com sucesso.')
            this.$router.push('/cerebro/entities')
          }).catch(err => {
            console.log(err.response)
            this.showError('Ops. Ocorreu um erro ao salvar a entidade ')
            this.$router.push('/cerebro/entities')
          })
        }
      }
    }
  }
}
</script>
<style>
  div.jsoneditor {
    border: 1px solid #9e9e9e;
  }

  div.jsoneditor-menu {
    background-color: #9e9e9e;
    border-bottom: 1px solid #9e9e9e;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?7ea3e5f6